import { gql } from "@apollo/client";
export const GET_LIQUIDITY_TVL = gql`
  query getLiquidityTvl($fromTimestamp: Int, $toTimestamp: Int) {
    liquidityStatistics(
      where: { fromTimestamp: $fromTimestamp, toTimestamp: $toTimestamp }
    ) {
      value
      timestamp
    }
  }
`;

export const GET_POOL_NET_VALUE = gql`
  query getPoolNetValue(
    $fromTimestamp: Int
    $toTimestamp: Int
  ) {
    lpNetValueStatistics(
      where: {
        fromTimestamp: $fromTimestamp
        toTimestamp: $toTimestamp
      }
    ) {
      value
      timestamp
    }
  }
`;

export const GET_TRADE_VOLUME = gql`
  query getMarginTvl(
    $fromTimestamp: Int
    $toTimestamp: Int
  ) {
    volumeStatistics(
      where: {
        fromTimestamp: $fromTimestamp
        toTimestamp: $toTimestamp
      }
    ) {
      value
      timestamp
    }
  }
`;



export const GET_LIQUIDITY_TOKEN = gql`
  query getLiquidityTokenValue {
    tokenValue: liquidityDistributions{
      value
      token
    }
  }
`;

export const GET_MARGIN_TOKEN = gql`
  query getMarginTokenValue {
    tokenValue: marginDistributions{
      value
      token
    }
  }
`;

export const GET_LIQUIDITY_DETAILS = gql`
  query getLiquidityDetails(
    $limit: Int
    $offset: Int
  ) {
    liquidityDetails(
      where: {
        limit: $limit
        offset: $offset
      }
    ) {
      account
      action
      amount
      chainId
      assetSymbol
      liquidity
      timestamp
      totalCount
    }
  }
`;

export const GET_TRADE_DETAILS = gql`
  query getTradeDetails(
    $limit: Int
    $offset: Int
  ) {
    tradeDetails(
      where: {
        limit: $limit
        offset: $offset
      }
    ) {
      account
      direction
      notional
      chainId
      price
      symbol
      timestamp
      totalCount
      volume
    }
  }
`;
